// extracted by mini-css-extract-plugin
module.exports = {"previewContainer":"PreviewReceipt_previewContainer__uYyTf","canvas":"PreviewReceipt_canvas__f7qJJ"};